import styles from './Introduction.module.css';
import { IntroductionMainContent } from './IntroductionMainContent';
import { IntroductionMedia } from './IntroductionMedia';

interface IntroductionProps {
  mediaUrl: string;
  title: string;
  paragraphs: string[];
  tags: {
    heading: string;
    items: string[];
  }[];
}

export const Introduction = ({ mediaUrl, title, paragraphs, tags }: IntroductionProps) => {
  return (
    <div className={styles.introductionSection}>
      <IntroductionMainContent title={title} paragraphs={paragraphs} tags={tags} />
      <IntroductionMedia mediaSrc={mediaUrl} />
    </div>
  );
};
